import { Box } from '@mui/material'
import { FC } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import Carousel from '@/common/components/Carousel/Carousel'
import { DeviceType } from '@/common/hooks/useDeviceDetection'
import { useUrlSearchQuery } from '@/common/hooks/useUrlQuery'
import { theme } from '@/theme/theme'
import { Video } from '@/types/videos'
import VideoCard from './VideoCard'

type VidesoCarouseParams = {
  videos: Video[]
  currentVideoId?: string
  deviceType?: DeviceType
}

const VideosCarousel: FC<VidesoCarouseParams> = ({ videos, currentVideoId, deviceType }) => {
  const navigateTo = useNavigate()
  const { token } = useParams()
  const queryParams = useUrlSearchQuery()

  const handleVideoClick = (videoId: string) => {
    navigateTo(`/content/training-campaign/${token}?language=${queryParams.language}&video_id=${videoId}`)
  }
  return (
    <Box marginTop={theme.spacing(5)} maxWidth={theme.spacing(130)} marginX="auto">
      {deviceType !== DeviceType.Mobile ? (
        <Carousel title={`Next Training In Queue (${videos.length})`}>
          {videos.map((video: Video) => (
            <VideoCard
              key={video.id}
              video={video}
              handleVideoClick={handleVideoClick}
              isCurrentVideo={video.id === currentVideoId}
              deviceType={deviceType}
            />
          ))}
        </Carousel>
      ) : (
        <>
          {videos.map((video: Video) => (
            <Box position="relative">
              <VideoCard
                key={video.id}
                video={video}
                handleVideoClick={handleVideoClick}
                isCurrentVideo={video.id === currentVideoId}
                deviceType={deviceType}
              />
            </Box>
          ))}
        </>
      )}
    </Box>
  )
}

export default VideosCarousel
